import React, { useEffect, useState } from 'react';
import * as moment from "moment-timezone";
import Icon from '@ant-design/icons';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { Transition } from "react-transition-group";
import SoldOutModal from "./soldOut";
import { getEventDetailsById } from "../../api";

import {
    Button,
    Spinner
} from "../../design";
import bookWithButton from '../../assets/imgs/Book With_Button_Rounded.svg'
import EmailIcon from "../../assets/imgs/email.svg";
import PhoneIcon from "../../assets/imgs/call.svg";

type Props = {
    history: {
        push: Function,
    },
}


const Events = (props: Props) => {

    const { match: { params: { eventLinkId } }, location: { pathname, search } } = props;
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [mobileView, setMobileView] = useState(false);
    const [mapDisplay, setMapDisplay] = useState(false);
    const [accountGid, setAccountGid] = useState();
    const accGid = [
        "account-b6dbb0f37b954706ab9520ba6de349a8",
        "account-78ce8313809a4f3c9fd5676e9386cb63"
    ];
    const donarGid = [
      "account-09ae999eda5a44f88c6278b4730813d8"
    ];

    useEffect(() => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 480) {
            setMobileView(true);
        }
    }, []);

    useEffect(() => {
        getEventDataWithoutSearchValue();
        localStorage.removeItem("seatsData");
    }, [eventLinkId, search]);

    const getEventDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, null);
            if (value && value.account) {
                setAccountGid(value.account && value.account.gid)
            }
            if (value && value.seatPageMeta) {
                setEventDetails(value.seatPageMeta)
            }

        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getOperatingTime = (time) => {
        if (time !== 0) {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            let min;
            if (minutes < 10) {
                min = `0${minutes}`;
            } else if (minutes >= 10) {
                min = minutes;
            }
            if (hours > 12) {
                const hr = hours - 12;
                return `${hr}:${min} PM`;
            }
            if (hours === 0) {
                return `${12}:${min} AM`;
            }
            return `${hours}:${min} AM`;
        }
        return '12:00 AM';
    };

    const bookTickets = () => {
        props.history.push(`${pathname}/seats`);
    };

    const getDuration = (data) => {
        if (data) {
            const diff = data.eventEndTime - data.eventStartTime;
            const hours = Math.floor(diff / 60);
            const minutes = diff % 60;
            let min;
            if (minutes < 10) {
                min = `0${minutes}`;
            } else if (minutes >= 10) {
                min = minutes;
            }
            if (hours > 12) {
                const hr = hours - 12;
                return `${hr}:${min}`;
            }
            if (hours === 0) {
                return `00:${min}`;
            }
            return `${hours}:${min}`;
        }
        return '12:00';
    }

    const toggleMap = () => {
        setMapDisplay(!mapDisplay);
    };

    const redirectToSiteDonate = () => {
      const siteUrl = 'https://www.swirepay.com/valmikisponsor';
        window.open(siteUrl, '_blank');
    }

    const redirectToSite = () => {
        const siteUrl = 'https://www.swirepay.com/aramdonation';
        window.open(siteUrl, '_blank');
    };

    return (
        <div className='ml-4 mr-4'>
            <div
                className="mt-4 mb-4"
                style={{
                    justifyContent: 'start',
                }}
            >
                <p style={{ fontSize: '18px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}</p>
            </div>
            <div
                className="mt-4 mb-4"
                style={{
                    justifyContent: 'start',
                }}
            >
                <p style={{ fontSize: '24px', fontWeight: '700' }}>{eventDetails && eventDetails.title}</p>
            </div>
            {
                eventDetails && !eventDetails.seatEventId && !mobileView ? (
                    <>
                        <div
                            className="mt-4 mb-4"
                            style={{
                                display: 'flex',
                                justifyContent: 'start',
                                alignItems: 'start',
                            }}
                        >
                            <div className='ml-4 mr-4'>
                                <img src={eventDetails && eventDetails.banner} style={{ width: '450px', objectFit: 'cover' }} />
                            </div>
                            <div>
                                <div
                                    className="mt-4 mb-4"
                                    style={{
                                        justifyContent: 'start',
                                        display: 'flex',
                                    }}
                                >
                                    <p style={{ fontSize: '20px', fontWeight: '600' }}>When and where</p>
                                </div>
                                <div
                                    // className="mb-4"
                                    style={{
                                        display: mobileView ? '' : 'flex',
                                    }}
                                >
                                    <div
                                        className="mb-4"
                                        style={{
                                            display: 'flex',
                                            width: mobileView ? '100%' : eventDetails && eventDetails.venueAddress ? '35%' : '50%',
                                            justifyContent: 'start',
                                        }}
                                    >
                                        <Icon type='calendar' style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                        <div className='mr-2'>
                                            <p className='mb-2' style={{ fontSize: '18px', fontWeight: '600' }}>Date and time</p>
                                            {
                                                eventDetails && eventDetails.eventEndTime ? (
                                                    <p style={{ fontSize: '16px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)} - {getOperatingTime(eventDetails && eventDetails.eventEndTime)}</p>
                                                ) : (
                                                    <p style={{ fontSize: '16px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)}</p>
                                                )
                                            }
                                        </div>

                                    </div>
                                    <div
                                        className="mb-4"
                                        style={{
                                            display: 'flex',
                                            width: mobileView ? '100%' : '50%',
                                            justifyContent: 'start',
                                        }}
                                    >
                                        {
                                            eventDetails && eventDetails.venueAddress && (
                                                <>
                                                <Icon type='pushpin' style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                        <div className='mr-2'>
                                            <p className='mb-2' style={{ fontSize: '18px', fontWeight: '600' }}>Location</p>
                                            <p style={{ fontSize: '16px' }}>{eventDetails && eventDetails.venueAddress}</p>
                                            <p className='mt-2' style={{ fontSize: '16px' }}><span style={{ color: '#3f77e7', cursor: 'pointer' }} onClick={toggleMap} >{!mapDisplay ? 'Show map...' : 'Hide map...'}</span></p>
                                        </div>
                                                </>
                                            )
                                        }
                                        <div
                                            className="mb-4"
                                            style={{
                                                width: mobileView ? '100%' : '15%',
                                                justifyContent: 'start',
                                            }}
                                        >
                                            {eventDetails && !['SOLD_OUT', 'DEACTIVATED'].includes(eventDetails.status) && (
                                                <button class='border-0 mb-5' style={{ background: 'transparent' }}
                                                    disabled={eventDetails && eventDetails.status !== 'ACTIVE'}
                                                    type="submit" onClick={bookTickets}
                                                ><img src={bookWithButton} alt="payButton" height='60' /></button>
                                            )}

                        {
                          donarGid.includes(accountGid) ? (
                            <Button type="primary"
                              border="2px solid #40A9FF !important"
                              color="#FFFFFF !important"
                              paddingRight="1.5rem"
                              paddingTop=".4rem"
                              paddingBottom=".4rem"
                              borderRadius="50px"
                              paddingLeft="1.5rem"
                              marginBottom="10px"
                              onClick={redirectToSiteDonate}
                              width="250px"
                              height="50px"
                              style={{
                                fontSize: "18px"
                              }}
                            >
                              Donate With Swirepay
                            </Button>
                          ) : null
                        }

                                        </div>
                                    </div>
                                </div>
                                {
                                    eventDetails && (
                                        <div
                                            // className="mb-4"
                                            id="location-info"
                                            style={{
                                                justifyContent: 'start',
                                                height: '400px',
                                                position: 'relative',
                                                display: mapDisplay ? '' : 'none'
                                            }}
                                        >
                                            <Map
                                                google={props.google}
                                                zoom={14}
                                                style={{ height: '350px' }}
                                                initialCenter={{ lat: eventDetails.coordinate && eventDetails.coordinate.x, lng: eventDetails.coordinate && eventDetails.coordinate.y }}
                                            >
                                                <Marker position={{ lat: eventDetails.coordinate && eventDetails.coordinate.x, lng: eventDetails.coordinate && eventDetails.coordinate.y }} />
                                            </Map>
                                        </div>
                                    )
                                }
                                {/* <div
                                    className="mb-4"
                                    style={{
                                        justifyContent: 'start',
                                    }}
                                >
                                    <p style={{ fontSize: '20px', fontWeight: '600' }}>Refund Policy</p>
                                </div>
                                <div
                                    className="mb-4"
                                    style={{
                                        justifyContent: 'start',
                                    }}
                                >
                                    <p style={{ fontSize: '16px' }}>No Refunds</p>
                                </div>

                                <hr /> */}
                                <div>
                                    <div
                                        className="mb-4"
                                        style={{
                                            justifyContent: 'start',
                                        }}
                                    >
                                        <p style={{ fontSize: '20px', fontWeight: '600' }}>About this event</p>
                                    </div>
                                    {
                                        eventDetails && eventDetails.eventEndTime ? (
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                <>
                                                    <Icon type="clock-circle-o" style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                                    <div className='mr-2'>
                                                        <p className='mt-1' style={{ fontSize: '18px' }}>{eventDetails && getDuration(eventDetails)} hours</p>
                                                    </div>
                                                </>
                                            </div>
                                        ) : null
                                    }
                                    {
                                        eventDetails && eventDetails.description && (
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                <p className="mt-1" style={{ fontSize: '16px', wordBreak: 'break-word', lineHeight: '1.5em' }}><div dangerouslySetInnerHTML={{ __html: eventDetails && eventDetails.description }} /></p>
                                            </div>
                                        )
                                    }
                                </div>
                                <hr />
                                {
                                    eventDetails && eventDetails.termsAndConditions && (
                                        <>
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                <p className="mt-1" style={{ fontSize: '16px', wordBreak: 'break-word', lineHeight: '1.5em' }}><div dangerouslySetInnerHTML={{ __html: eventDetails && eventDetails.termsAndConditions }} /></p>
                                            </div>
                                        </>
                                    )
                                }
                                <hr />
                                {
                                    ((eventDetails && eventDetails.contactUsEmail) || (eventDetails && eventDetails.contactUsPhone)) ? (
                                        <>
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                <p style={{ fontSize: '20px', fontWeight: '600' }}>For any inquiries, please contact</p>
                                            </div>
                                            {
                                                eventDetails && eventDetails.contactUsEmail && (
                                                    <div
                                                        className="mb-4"
                                                    >
                                                        <div className="d-flex">
                                                            <span className="pr-2">
                                                                <img src={EmailIcon} alt="" />
                                                            </span>
                                                            <a href={`mailto:${eventDetails.contactUsEmail}`}>{eventDetails.contactUsEmail}</a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                eventDetails && eventDetails.contactUsPhone && (
                                                    <div
                                                        className="mb-4"
                                                    >
                                                        <div className="d-flex">
                                                            <span className="pr-2">
                                                                <img src={PhoneIcon} alt="" />
                                                            </span>
                                                            <a href={`mailto:${eventDetails.contactUsPhone}`}>{eventDetails.contactUsPhone}</a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <hr />
                                        </>
                                    ) : null
                                }

                                {
                                    accGid.includes(accountGid) ? (
                                        <Button type="primary"
                                            border="2px solid #40A9FF !important"
                                            color="#FFFFFF !important"
                                            paddingRight="1.5rem"
                                            paddingTop=".4rem"
                                            paddingBottom=".4rem"
                                            borderRadius="50px"
                                            paddingLeft="1.5rem"
                                            marginBottom="10px"
                                            onClick={redirectToSite}
                                            width="250px"
                                            height="50px"
                                            style={{
                                                fontSize: "18px"
                                            }}
                                        >
                                            Donate With Swirepay
                                        </Button>
                                    ) : null
                                }

                            </div>
                        </div>
                        {/* <div
                            className="mt-4 mb-4"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <p style={{ fontSize: '14px', fontWeight: '700' }}>If you have not renewed 2024 TVKS membership, please renew ASAP before buying Rajyotsava 2023 event tickets <a href="http://tvksangha.org/renew_membership.php" target="_blank" >
                                Click here.
                            </a></p>
                        </div> */}
                    </>
                ) : (
                    <>
                        <div
                            className="mt-4 mb-4"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <img src={eventDetails && eventDetails.banner} style={{ width: mobileView ? '300px' : '400px', objectFit: 'cover' }} />
                        </div>
                        {/* {
                            eventDetails && !eventDetails.seatEventId && (
                                <div
                                    className="mt-4 mb-4"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <p style={{ fontSize: '14px', fontWeight: '700' }}>If you have not renewed 2024 TVKS membership, please renew ASAP before buying Rajyotsava 2023 event tickets <a href="http://tvksangha.org/renew_membership.php" target="_blank" >
                                        Click here.
                                    </a></p>
                                </div>
                            )
                        } */}

                        <div
                            className="mt-4 mb-4"
                            style={{
                                justifyContent: 'start',
                            }}
                        >
                            <p style={{ fontSize: '20px', fontWeight: '600' }}>When and where</p>
                        </div>
                        <div
                            className="mb-4"
                            style={{
                                display: mobileView ? '' : 'flex',
                            }}
                        >
                            <div
                                className="mb-4"
                                style={{
                                    display: 'flex',
                                    width: mobileView ? '100%' : '30%',
                                    justifyContent: 'start',
                                }}
                            >
                                <Icon type='calendar' style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                <div className='mr-2'>
                                    <p className='mb-2' style={{ fontSize: '18px', fontWeight: '600' }}>Date and time</p>
                                    {
                                        eventDetails && eventDetails.eventEndTime ? (
                                            <p style={{ fontSize: '16px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)} - {getOperatingTime(eventDetails && eventDetails.eventEndTime)}</p>
                                        ) : (
                                            <p style={{ fontSize: '16px' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)}</p>
                                        )
                                    }
                                </div>

                            </div>
                            <div
                                className="mb-4"
                                style={{
                                    display: 'flex',
                                    width: mobileView ? '100%' : '30%',
                                    justifyContent: 'start',
                                }}
                            >
                                <Icon type='pushpin' style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                <div className='mr-2'>
                                    <p className='mb-2' style={{ fontSize: '18px', fontWeight: '600' }}>Location</p>
                                    <p style={{ fontSize: '16px' }}>{eventDetails && eventDetails.venueAddress}</p>
                                    <p className='mt-2' style={{ fontSize: '16px' }}><span style={{ color: '#3f77e7', cursor: 'pointer' }} onClick={toggleMap} >{!mapDisplay ? 'Show map...' : 'Hide map...'}</span></p>
                                </div>

                            </div>
                            <div
                                className="mb-4"
                                style={{
                                    width: mobileView ? '100%' : '30%',
                                    justifyContent: 'start',
                                }}
                            >
                                {eventDetails && !['SOLD_OUT', 'DEACTIVATED'].includes(eventDetails.status) && (
                                    <button class='border-0 mb-5' style={{ background: 'transparent' }}
                                        disabled={eventDetails && eventDetails.status !== 'ACTIVE'}
                                        type="submit" onClick={bookTickets}
                                    ><img src={bookWithButton} alt="payButton" height='60' /></button>
                                )}
                                {
                        donarGid.includes(accountGid) ? (
                          <Button type="primary"
                            border="2px solid #40A9FF !important"
                            color="#FFFFFF !important"
                            paddingRight="1.5rem"
                            paddingTop=".4rem"
                            paddingBottom=".4rem"
                            borderRadius="50px"
                            paddingLeft="1.5rem"
                            marginBottom="10px"
                            onClick={redirectToSiteDonate}
                            width="250px"
                            height="50px"
                            style={{
                              fontSize: "18px"
                            }}
                          >
                            Donate With Swirepay
                          </Button>
                        ) : null
                      }

                            </div>
                        </div>
                        {
                            eventDetails && (
                                <div
                                    className="mb-4"
                                    id="location-info"
                                    style={{
                                        justifyContent: 'start',
                                        height: '400px',
                                        position: 'relative',
                                        display: mapDisplay ? '' : 'none'
                                    }}
                                >
                                    <Map
                                        google={props.google}
                                        zoom={14}
                                        style={{ height: '350px' }}
                                        initialCenter={{ lat: eventDetails.coordinate && eventDetails.coordinate.x, lng: eventDetails.coordinate && eventDetails.coordinate.y }}
                                    >
                                        <Marker position={{ lat: eventDetails.coordinate && eventDetails.coordinate.x, lng: eventDetails.coordinate && eventDetails.coordinate.y }} />
                                    </Map>
                                </div>
                            )
                        }


                        {/* <div
                            className="mb-4"
                            style={{
                                justifyContent: 'start',
                            }}
                        >
                            <p style={{ fontSize: '20px', fontWeight: '600' }}>Refund Policy</p>
                        </div>
                        <div
                            className="mb-4"
                            style={{
                                justifyContent: 'start',
                            }}
                        >
                            <p style={{ fontSize: '16px' }}>No Refunds</p>
                        </div> */}
                        <div
                            className="mb-4"
                            style={{
                                justifyContent: 'start',
                                fontFamily: 'sans-serif'
                            }}
                        >
                            <p className="mt-2" style={{ fontSize: '16px', wordBreak: 'break-word', lineHeight: '1.5em' }}><div dangerouslySetInnerHTML={{ __html: eventDetails && eventDetails.description }} /></p>
                        </div>
                        <div
                            className="mt-4 mb-2"
                            style={{
                                justifyContent: 'start',
                            }}
                        >
                            <p style={{ fontSize: '20px', fontWeight: '600' }}>About this event</p>
                        </div>
                        <div
                            className="mb-4"
                            style={{
                                display: mobileView ? '' : 'flex',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    width: mobileView ? '100%' : '30%',
                                    justifyContent: 'start',
                                }}
                            >

                                {
                                    eventDetails && eventDetails.eventEndTime ? (
                                        <>
                                            <Icon type="clock-circle-o" style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                            <div className='mr-2'>
                                                <p className='mt-1' style={{ fontSize: '18px' }}>{eventDetails && getDuration(eventDetails)} hours</p>
                                            </div>
                                        </>
                                    ) : (
                                        <div className='mr-2'>
                                            <p className='mt-1' style={{ fontSize: '18px' }}>&nbsp;</p>
                                        </div>
                                    )
                                }
                            </div>
                            <div
                                className="mb-4"
                                style={{
                                    display: 'flex',
                                    width: mobileView ? '100%' : '30%',
                                    justifyContent: 'start',
                                }}
                            >
                                <Icon type='scan' style={{ marginRight: '10px', fontSize: '20px', color: '#3f77e7' }} />
                                <div className='mr-2'>
                                    <p className='mt-1' style={{ fontSize: '18px' }}>Mobile Tickets</p>
                                </div>

                            </div>
                        </div>

                        {/* {
                            eventDetails && eventDetails.description ? (
                                <div
                                    className="mb-4"
                                    style={{
                                        justifyContent: 'start',
                                        fontFamily: 'sans-serif'
                                    }}
                                >
                                    <p className="mt-2" style={{ fontSize: '18px', wordBreak: 'break-word', lineHeight: '1.5em' }}><div dangerouslySetInnerHTML={{ __html: eventDetails && eventDetails.description }} /></p>
                                </div>
                            ) : null
                        } */}

                        {
                            eventDetails && eventDetails.termsAndConditions ? (
                                <>
                                    <div
                                        className="mb-4"
                                        style={{
                                            justifyContent: 'start',
                                            fontFamily: 'sans-serif'
                                        }}
                                    >
                                        <p style={{ fontSize: '18px', wordBreak: 'break-word', lineHeight: '1.5em' }}><div dangerouslySetInnerHTML={{ __html: eventDetails && eventDetails.termsAndConditions }} /></p>
                                    </div>

                                </>
                            ) : null
                        }
                        {
                                    ((eventDetails && eventDetails.contactUsEmail) || (eventDetails && eventDetails.contactUsPhone)) ? (
                                        <>
                                            <div
                                                className="mb-4"
                                                style={{
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                <p style={{ fontSize: '20px', fontWeight: '600' }}>For any inquiries, please contact</p>
                                            </div>
                                            {
                                                eventDetails && eventDetails.contactUsEmail && (
                                                    <div
                                                        className="mb-4"
                                                    >
                                                        <div className="d-flex">
                                                            <span className="pr-2">
                                                                <img src={EmailIcon} alt="" />
                                                            </span>
                                                            <a href={`mailto:${eventDetails.contactUsEmail}`}>{eventDetails.contactUsEmail}</a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                eventDetails && eventDetails.contactUsPhone && (
                                                    <div
                                                        className="mb-4"
                                                    >
                                                        <div className="d-flex">
                                                            <span className="pr-2">
                                                                <img src={PhoneIcon} alt="" />
                                                            </span>
                                                            <a href={`tel:${eventDetails.contactUsPhone}`}>{eventDetails.contactUsPhone}</a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <hr />
                                        </>
                                    ) : null
                                }
                        {
                            accGid.includes(accountGid) ? (
                                <Button type="primary"
                                    border="2px solid #40A9FF !important"
                                    color="#FFFFFF !important"
                                    paddingRight="1.5rem"
                                    paddingTop=".4rem"
                                    paddingBottom=".4rem"
                                    borderRadius="50px"
                                    paddingLeft="1.5rem"
                                    marginBottom="10px"
                                    onClick={redirectToSite}
                                    width="250px"
                                    height="50px"
                                    style={{
                                        fontSize: "18px"
                                    }}
                                >
                                    Donate With Swirepay
                                </Button>
                            ) : null
                        }

                    </>
                )
            }

            <Spinner isOpen={isShowSpinner} />
            <SoldOutModal title={eventDetails && eventDetails.title} body="We are sold out for this event" header="Sorry!" isOpen={eventDetails && eventDetails.status === 'SOLD_OUT'} />
        </div>
    )
};

export default GoogleApiWrapper({
    apiKey: 'AIzaSyCLR2kMaQ9AHIa_tqsG48hxA9CZ7ullXds'
})(Events);
